import { Button } from '@carbon/react';
import { Add, Edit, Location } from '@carbon/react/icons';
import { useSetAtom } from 'jotai';

import { tcDetailsRightPanelAtom } from './atoms';
import styles from './tc-area-picker-button.module.scss';

interface TcAreaPickerButtonProps {
  typeCurveAreaName?: string | null;
}

export const TcAreaPickerButton = ({
  typeCurveAreaName,
}: TcAreaPickerButtonProps) => {
  const setRightPanel = useSetAtom(tcDetailsRightPanelAtom);

  const openAreaPanel = () => {
    setRightPanel({ type: 'tc-area', open: true });
  };

  // Selected — inline row mirroring the DCA Scenario row.
  if (typeCurveAreaName) {
    return (
      <div className={styles.selectedRow}>
        <span className={styles.label}>Type Curve Area:</span>
        <span className={styles.name}>{typeCurveAreaName}</span>
        <Button
          hasIconOnly
          kind="ghost"
          size="sm"
          className={styles.edit}
          onClick={openAreaPanel}
          iconDescription="Edit Type Curve Area"
          tooltipPosition="top"
          renderIcon={Edit}
        />
      </div>
    );
  }

  // Empty — "Start here" prompt with the primary call to action.
  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyHeader}>
        <Location size={20} className={styles.emptyIcon} />
        <span className={styles.emptyTitle}>
          Start here: set a Type Curve Area
        </span>
      </div>
      <p className={styles.emptyDescription}>
        A Type Curve Area defines which wells are included. Set it first to
        build this type curve&apos;s inventory.
      </p>
      <Button
        kind="primary"
        size="md"
        className={styles.setButton}
        onClick={openAreaPanel}
        renderIcon={Add}
      >
        Set Type Curve Area
      </Button>
    </div>
  );
};
